<template>
  <swiper ref="mySwiper1" :options="swiperOptions">
    <swiper-slide>
      <div style="width: 80%;height: 80%">
        <img src="../assets/img/bgtop.jpg">
      </div>
    </swiper-slide>
    <swiper-slide>
      <div style="width: 80%;height: 80%">
        <img src="../assets/img/bgtop.jpg">
      </div>
    </swiper-slide>
    <swiper-slide>
      <div style="width: 80%;height: 80%">
        <img src="../assets/img/bgtop.jpg">
      </div>
    </swiper-slide>
    <swiper-slide>
      <div style="width: 80%;height: 80%">
        <img src="../assets/img/bgtop.jpg">
      </div>
    </swiper-slide>
    <swiper-slide>
      <div style="width: 80%;height: 80%">
        <img src="../assets/img/bgtop.jpg">
      </div>
    </swiper-slide>
    <swiper-slide>
      <div style="width: 80%;height: 80%">
        <img src="../assets/img/bgtop.jpg">
      </div>
    </swiper-slide>
    <swiper-slide>
      <div style="width: 80%;height: 80%">
        <img src="../assets/img/bgtop.jpg">
      </div>
    </swiper-slide>
    <swiper-slide>
      <div style="width: 80%;height: 80%">
        <img src="../assets/img/bgtop.jpg">
      </div>
    </swiper-slide>
    <swiper-slide>
      <div style="width: 80%;height: 80%">
        <img src="../assets/img/bgtop.jpg">
      </div>
    </swiper-slide>
<!--    <div class="swiper-pagination" slot="pagination"></div>-->
  </swiper>
</template>

<script>
export default {
  name: "myswipper",
  data(){
    return{
      swiperOptions: {
        slidesPerView: 3,//显示个数
        direction: 'horizontal',
        pagination: {
          el: '.swiper-pagination'
        },
        autoplay: {
          disableOnInteraction: false,  // 用户操作swiper之后，是否禁止autoplay
          delay: 1500, // 自动切换的时间间隔（单位ms）
        },
        loop:true
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper1.swiper
    }
  },
  mounted() {
    this.swiper.slideTo(3, 1000, false)
  }
}
</script>

<style scoped>
.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  height: 200px;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
img{
  width: 100%;
  height: 100%;
}
</style>
